let template = {
    template: "Template",
    addTemplate: "Add Template",
    editTemplate: "Edit Template",
    templateDetail: "Template Detail",
    setTurnOnOffTemplate: "Set the power-on/off template",
    setTurnOnTemplate: "Set the power-on template",
    setTurnOffTemplate: "Set the power-off template",
    turnOnTemplateContent: "Power-on template",
    turnOffTemplateContent: "Power-off template",
    orgTemplateConfig: "Organization {name} template configuration",
    deviceTemplateConfig: "Device {name} template configuration",
    status: "Template Status",
    templateName: "Template Name",
    enterTemplateName: "Please enter the template name",
    templateContent: "Template Content",
    enterTemplateContent: "Please enter the template content",
    templateNumber: "Template Number",
    templateType: "Template Type",
    languageType: "Language",
    selTemplateType: "Please select template type",
    messageTemplate: "Message Template",
    poweronTemplate: "Power-on Template",
    poweroffTemplate: "Power-off Template",
    currencyTemplate: "Currency Template",
    lang_cn: "中文",
    lang_en: "English",
    lang_id: "Hindi",
    lang_am: "Amharic",
    type_prefix: "prefix",
    type_suffix: "suffix",
    printTemplate: "Print Template",
    logoTemplate: "Logo template",
    audioType: "Audio type",
    speechSpeed: "Speech speed",
    selSpeechSpeed: "Please select speech speed",
    generationType: "Generation method",
    onlineGeneration: "Online generation",
    audioFileRequired: "Please upload your mp3 file",
    fileTypeInvalid: "Only mp3 file supported",
    fileTooLarge: "File too large, the maximum is 8Kb",
    pleaseGenerateFile: "Please generate file",
    fileUpload: "File upload",
    unaudited: "unaudited",
    audited: "audited",
    selTemplate: "Please select a template",
    reUpload: "Re-upload",
    availableResources: "Resources",
    resourceDetail: "Resource detail",
    instructionSet: "Instruction set",
    example: "Example",
    displayPotion: "Display location",
    selDisplayPotion: "Please select display location",
    alignLeft: "Left alignment",
    alignRight: "Right alignment",
    alignCenter: "Center alignment",
    marginTop: "Top (mm)",
    enterMarginTop: "Please enter top (mm), range 0-10",
    marginBottom: "Bottom (mm)",
    enterMarginBottom: "Please enter bottom (mm), range 0-10",
    logoPicUpload: "Logo upload",
    logoCmd:{
        text: "LOGO",
        title: "LOGO label, ID=LOGO ID, select the logo to print from this template",
    },
    tCmd: {
        text: "Plain text",
        title: "Properties can be set within the tag, and the following content follows this format",
    },
    spCmd: {
        text: "Separator",
        title: "Automatically print a whole line --------------------------",
    },
    blCmd: {
        text: "Blank row",
        title: "Insert Blank Line",
    },
    qrCmd: {
        text: "QR code",
        title: "Automatically convert content to QR code",
    },
    barCmd: {
        text: "Bar code",
        title: "Automatically convert content to bar code"
    },
    tabCmd: {
        text: "Table",
        title: "Example:<TAB COL=[3,2,1]>represents a 3-column table with a column width ratio of 3:2:1, and the number of rows is determined by the length of the passed parameter two-dimensional array"
    },
    alCmd: {
        text: "Align",
        title: "1 left alignment、2 center alignment、3 right alignment，default 1"
    },
    szCmd: {
        text: "Font size",
        title: "Font sizes 1-6 increase sequentially，default 2"
    },
    bdCmd: {
        text: "Bold font",
        title: "0 Normal，1 Bold，default 0"
    },
    wdCmd: {
        text: "QR code width",
        title: "Range 1-10, mapping based on actual situation, default 6"
    },
    scCmd: {
        text: "Print readable characters at the bottom of the barcode",
        title: "0 printing, 1 not printing, default 0"
    },
    printDisplay: {
        merchantName: "Merchant Name",
        testMerchant: "Test Merchant",
        merchantNo: "Merchant No",
        terminalNo: "Terminal No",
        payStatus: "Pay Status",
        payFinish: "Finish",
        payChannel: "Payment Method",
        alipay: "Alipay",
        messageId: "Message ID",
        tradeTime: "Trade Time",
        tradeAmount: "Amount",
        discountAmount: "Discount Amount",
        tradeNo: "Trade No",
        hotLine: "24-hour customer service hotline",
    },
    max32: "Template name too long, the maximum is 32",
    max64: "Template content too long, the maximum is 64",







}

export default template
